import { clientV3SDK, queryClient } from "@istari-frontend/api-client";
import { useMutation } from "@tanstack/react-query";

import { EditAccess } from "../model/secure-connection";
import { secureConnectionQueryKeys } from "./api/secure-connection-query-options";

export interface ShareFileToSendingConnectionArgs {
  connectionId: string;
  fileId: string;
  // Resource id whose shares query is invalidated on success — the list endpoint
  // is keyed by the owning resource, not the file.
  resourceId: string;
  // Requested per-share access level. The SDK accepts either Editor or Viewer;
  // calling share again with a different level updates the existing share.
  editAccess: EditAccess;
}

export function useShareFileToSendingConnection() {
  return useMutation({
    mutationFn: ({ connectionId, fileId, editAccess }: ShareFileToSendingConnectionArgs) =>
      clientV3SDK.shareFileToSendingRemote({
        remoteId: connectionId,
        fileId,
        shareFileToSendingRemoteDto: { shareLevel: editAccess === "editor" ? "Editor" : "Viewer" },
      }),
    onSuccess: (_data, { resourceId }) => {
      void queryClient.invalidateQueries({ queryKey: secureConnectionQueryKeys.sharesForResource(resourceId) });
      // A new share triggers a fresh sync attempt — drop the cached per-resource sync status
      // so the details pane stops reporting Complete/Partial against a stale connection set.
      void queryClient.invalidateQueries({
        queryKey: secureConnectionQueryKeys.resourceSyncStatusByConnection(resourceId),
      });
    },
  });
}
